function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBot = function SvgBot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root",
    focusable: "false",
    viewBox: "-0.7 -0.7 6 6",
    height: 36,
    width: 36,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "M 4.7625,0.5291667 V 4.2333333 C 4.7625,4.524375 4.527021,4.7625 4.233333,4.7625 H 0.529166 C 0.238125,4.7625 0,4.524375 0,4.2333333 V 0.5291667 C 0,0.238125 0.238125,0 0.529166,0 H 4.233333 C 4.527021,0 4.7625,0.238125 4.7625,0.5291667 Z m -3.565481,1.499458 c -2e-6,0.3874518 0.390479,0.3513012 0.771927,0.3454167 l 0.810617,0.014222 c 0.395993,-0.00834 0.794274,0.00615 0.793121,-0.3885801 L 3.570284,1.1777361 C 3.580444,0.8061731 3.175556,0.79175585 2.771776,0.78643417 l -0.80535,0.007013 C 1.587498,0.79175517 1.197017,0.82790677 1.199897,1.2175902 Z m 2.771731,1.675542 c 0,-0.802112 10e-4,-0.8120029 -1.5875,-0.8202084 -1.596153,-0.00825 -1.5875,-0.015006 -1.5875,0.8202084 V 3.96875 h 3.175 z",
    style: {
      strokeWidth: 0.264583
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bot.db4f070b.svg";
export { ForwardRef as ReactComponent };